import React from "react"
import _ from "lodash"
import { Checkbox_s } from "styles/input-styles"

const CheckboxInput = (props: {field: string|string[], value: boolean, persist: Function, disabled?: boolean, className?: string}) => {
  return (
    <Checkbox_s
      disabled={props.disabled || false}
      className={props.className}
      onChange={(e) => props.persist(props.field, e.checked)}
      checked={props.value}>
    </Checkbox_s>
  )
}

export default CheckboxInput
